export enum ModelNames {
  DOCUMENTS = "documentos",
  PARTNERS = "users",
  NOTIFICATIONS = "notificacoes",
  TASKS = "tarefas",
  MEETINGS = "conversas",
}
